<template>
  <span>
      <div class="row justify-content-center bg-white pt-4 m-0">
    <div class="col-12 text-center">
      <h3 class="section-title-advantages">
        MŪSŲ SERVISO IŠSKIRTINUMAS!
      </h3>
    </div>
  </div>
  <div class="row justify-content-center m-5">
    <div class="section-divider-advantages"></div>
  </div>
  <div class="row justify-content-center align-items-stretch m-5 pb-3">
    <div class="col-12 col-md-6 col-lg-3 mb-4">
      <div class="advantage-card">
        <div class="advantage-icon-wrapper">
          <ChatAlt2Icon class="advantage-icon"></ChatAlt2Icon>
        </div>
        <h5 class="advantage-title">Ekspertinės konsultacijos</h5>
        <p class="advantage-text">Padedame klientams dėl automobilio būklės gerinimo (tik profesionalūs patarimai)</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 mb-4">
      <div class="advantage-card">
        <div class="advantage-icon-wrapper">
          <ClockIcon class="advantage-icon"></ClockIcon>
        </div>
        <h5 class="advantage-title">Greitumas</h5>
        <p class="advantage-text">Įvertiname mūsų klientų laiko svarbą ir užtrunkame kaip įmanoma trumpiau, suteikdami efektyvias paslaugas.</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 mb-4">
      <div class="advantage-card">
        <div class="advantage-icon-wrapper">
          <EmojiHappyIcon class="advantage-icon"></EmojiHappyIcon>
        </div>
        <h5 class="advantage-title">Kokybė</h5>
        <p class="advantage-text">Dauguma patenkintų klientų mus rekomenduotų savo šeimai, draugams bei kolegoms.</p>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 mb-4">
      <div class="advantage-card">
        <div class="advantage-icon-wrapper">
          <ClipboardCheckIcon class="advantage-icon"></ClipboardCheckIcon>
        </div>
        <h5 class="advantage-title">Pagalbos ranka</h5>
        <p class="advantage-text">Išvykus atgal į kelią – pagalba kelyje. Mūsų specialistai pasirengę padėti bet kurioje vietoje Lietuvos teritorijoje, todėl galite nesirūpinti ištikus nelaimei.</p>
      </div>
    </div>
  </div>
  </span>
</template>

<script>
import { ChatAlt2Icon, ClockIcon, EmojiHappyIcon, ClipboardCheckIcon} from '@heroicons/vue/outline'

export default {
  name: "OurAdvantages",
  components:{
    ChatAlt2Icon,
    ClockIcon,
    EmojiHappyIcon,
    ClipboardCheckIcon
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,500;1,300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300&display=swap');

.row {
  margin: 0px;
}

h1, h3 {
  font-family: 'Montserrat', sans-serif;
}

.section-title-advantages {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
  padding-top: 40px;
  letter-spacing: -0.02em;
}

.section-divider-advantages {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto;
}

.advantage-card {
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.advantage-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  border-color: #dc3545;
}

.advantage-icon-wrapper {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.3);
  transition: all 0.3s ease;
}

.advantage-card:hover .advantage-icon-wrapper {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.4);
}

.advantage-icon {
  width: 48px;
  height: 48px;
  color: white;
}

.advantage-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
}

.advantage-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 0.95rem;
  line-height: 1.7;
  color: #6c757d;
  margin: 0;
  flex: 1;
}

@media (max-width: 768px) {
  .advantage-card {
    padding: 30px 24px;
  }
  
  .advantage-icon-wrapper {
    width: 70px;
    height: 70px;
  }
  
  .advantage-icon {
    width: 40px;
    height: 40px;
  }
}
</style>